import React from 'react'

export default ({ color = '#666666' }) => {
    return (
        <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 1L6 6L1 0.999999" stroke={color} stroke-width="2" stroke-linecap="round" />
        </svg>
    )
}